import config from '@/config'; // eslint-disable-line import/extensions

/**
 * Причины возврата планировки заказчику.
 *
 * Ключ — техническое имя, `ru` — что видит пользователь в CRM,
 * `en` — что уходит заказчику по вебхуку.
 *
 * Список переопределяется через `declineReasons` в config.js: там задаётся
 * тот же формат, и он полностью заменяет значения по умолчанию.
 */
const DEFAULT_DECLINE_REASONS = {
  two_floors: { ru: 'Двухэтажная планировка', en: 'Two-storey floor plan' },
  cropped: { ru: 'Обрезанная планировка', en: 'Cropped floor plan' },
  unreadable: { ru: 'Нечитаемая планировка', en: 'Unreadable floor plan' },
  missing: { ru: 'Планировка отсутствует', en: 'Floor plan is missing' },
  other: { ru: 'Другое', en: 'Other' },
};

const getDeclineReasons = () => {
  const configured = config.declineReasons;

  if (!configured || typeof configured !== 'object' || !Object.keys(configured).length) {
    return DEFAULT_DECLINE_REASONS;
  }

  return configured;
};

/**
 * Опции для выпадающего списка. Значение опции — текст для заказчика:
 * именно он уходит на бэкенд и дальше в вебхук.
 *
 * @returns {Array<{value: string, label: string}>}
 */
const getDeclineReasonOptions = () => Object.entries(getDeclineReasons())
  .map(([key, reason]) => ({
    value: reason?.en ?? key,
    label: reason?.ru ?? key,
  }));

export {
  DEFAULT_DECLINE_REASONS,
  getDeclineReasons,
  getDeclineReasonOptions,
};
